import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedCardstourdesks,
  addingCardstourdesks,
  addingCardstourdesksFailed,
  CardstourdesksAction,
  CardstourdesksActionTypes,
  editedCardstourdesks,
  editingCardstourdesks,
  editingCardstourdesksFailed,
  foundCardstourdesks,
  loadedCardstourdesks,
  loadingCardstourdesks,
  loadingCardstourdesksFailed,
  removedCardstourdesk,
  removingCardstourdesk,
  removingCardstourdeskFailed,
  searchingCardstourdesks,
  searchingCardstourdesksFailed,
  softRemovedCardstourdesks,
  softRemovingCardstourdesks,
  softRemovingCardstourdesksFailed,
} from '../actions/cardstourdesksActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchCardstourdesksEpic: Epic<CardstourdesksAction, CardstourdesksAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardstourdesksActionTypes.SEARCH_CARDSTOURDESKS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/cardstourdesks/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundCardstourdesks(response.data, action.keep)),
        startWith(searchingCardstourdesks()),
        catchError(() => of(searchingCardstourdesksFailed()))
      )
    })
  )

const loadCardstourdesksEpic: Epic<CardstourdesksAction, CardstourdesksAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(CardstourdesksActionTypes.LOAD_CARDSTOURDESKS)),
    switchMap((action) => {
      let url = `${API_URL}/api/cardstourdesks/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedCardstourdesks(response.data)),
        startWith(loadingCardstourdesks()),
        catchError(() => of(loadingCardstourdesksFailed()))
      )
    })
  )
}

const addCardstourdesksEpic: Epic<CardstourdesksAction, CardstourdesksAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardstourdesksActionTypes.ADD_CARDSTOURDESKS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/cardstourdesks/`, data, config)).pipe(
        map((response) => addedCardstourdesks(response.data)),
        startWith(addingCardstourdesks()),
        catchError((err) => of(addingCardstourdesksFailed(err.response)))
      )
    })
  )

const removeCardstourdesksEpic: Epic<CardstourdesksAction, CardstourdesksAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardstourdesksActionTypes.REMOVE_CARDSTOURDESK)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/cardstourdesks/${action.payload._id}`)).pipe(
        map((response) => removedCardstourdesk()),
        startWith(removingCardstourdesk()),
        catchError(() => of(removingCardstourdeskFailed()))
      )
    )
  )

const softRemoveCardstourdesksEpic: Epic<CardstourdesksAction, CardstourdesksAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardstourdesksActionTypes.SOFT_REMOVE_CARDSTOURDESKS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/cardstourdesks/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedCardstourdesks(response.data.record)),
        startWith(softRemovingCardstourdesks()),
        catchError((err) => of(softRemovingCardstourdesksFailed(err.response)))
      )
    )
  )

const editCardstourdesksEpic: Epic<CardstourdesksAction, CardstourdesksAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardstourdesksActionTypes.EDIT_CARDSTOURDESKS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/cardstourdesks/${action.payload._id}`, data, config)).pipe(
        map((response) => editedCardstourdesks(response.data)),
        startWith(editingCardstourdesks()),
        catchError((err) => of(editingCardstourdesksFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchCardstourdesksEpic,
  loadCardstourdesksEpic,
  addCardstourdesksEpic,
  removeCardstourdesksEpic,
  softRemoveCardstourdesksEpic,
  editCardstourdesksEpic
)
